module.exports = __webpack_public_path__ + "img/fdi_logo_color.4e40b03f.png";